import React from 'react';
import { domToReact, DOMNode } from 'html-react-parser';
import { parseDocument } from 'htmlparser2';
import { LoadingSpinner, useFetch } from 'common.ui';
import Page from 'components/page/Page';
import { PrivacyPolicyResponse } from 'api/minside';
import { privacyPolicyClient } from 'api/MinSideClients';
import { useUser } from 'contexts/UserContext';
import './CurrentPrivacy.scss';

const CurrentPrivacy = () => {
  const { preferredLangauge } = useUser();

  // Teksten hentes fra API-et slik at MinSide og B2C-innlogginga viser samme personvernerklæring
  const [privacyPolicy, isLoading] = useFetch<PrivacyPolicyResponse>(
    () => privacyPolicyClient.apiPrivacyPolicyGet(),
    {} as PrivacyPolicyResponse,
    false,
    [preferredLangauge]
  );

  if (isLoading) {
    return <LoadingSpinner />;
  }

  // HTML-en parses til React-elementer i stedet for innerHTML, som er blokkert av
  // Trusted Types i CSP-en (require-trusted-types-for 'script')
  const content = domToReact(parseDocument(privacyPolicy.contentHtml ?? '').children as DOMNode[]);

  return <Page>{content}</Page>;
};

export default CurrentPrivacy;
